export default "__VITE_ASSET__4d6fdfbb__"